import { RefObject } from "react";

export const handleItemNavigation = (
  event: React.KeyboardEvent<HTMLDivElement>,
  optionRef: RefObject<HTMLDivElement>,
  onSelect: () => void,
) => {
  if (!optionRef) return;

  let prevOption: HTMLElement | null = null;
  let nextOption: HTMLElement | null = null;

  let sibling = optionRef.current?.previousSibling;
  while (sibling) {
    if (
      (sibling as HTMLElement).getAttribute("role") === "option" &&
      (sibling as HTMLElement).getAttribute("data-disabled") !== "true" //ignore disabled element when navigating
    ) {
      prevOption = sibling as HTMLElement;
      break;
    }
    sibling = sibling.previousSibling;
  }

  sibling = optionRef.current?.nextSibling;
  while (sibling) {
    if (
      (sibling as HTMLElement).getAttribute("role") === "option" &&
      (sibling as HTMLElement).getAttribute("data-disabled") !== "true" //ignore disabled element when navigating
    ) {
      nextOption = sibling as HTMLElement;
      break;
    }
    sibling = sibling.nextSibling;
  }

  if (!prevOption) {
    let lastChild = optionRef.current?.parentElement?.lastChild;
    while (lastChild) {
      if (
        (lastChild as HTMLElement).getAttribute("role") === "option" &&
        (lastChild as HTMLElement).getAttribute("data-disabled") !== "true" //ignore disabled element when navigating
      ) {
        prevOption = lastChild as HTMLElement;
        break;
      }
      lastChild = lastChild.previousSibling;
    }
  }

  if (!nextOption) {
    let firstChild = optionRef.current?.parentElement?.firstChild;
    while (firstChild) {
      if (
        (firstChild as HTMLElement).getAttribute("role") === "option" &&
        (firstChild as HTMLElement).getAttribute("data-disabled") !== "true" //ignore disabled element when navigating
      ) {
        nextOption = firstChild as HTMLElement;
        break;
      }
      firstChild = firstChild.nextSibling;
    }
  }

  switch (event.code) {
    case "ArrowUp":
      prevOption?.focus();
      event.preventDefault();
      break;
    case "ArrowDown":
      nextOption?.focus();
      event.preventDefault();
      break;
    case "Space":
    case "Enter":
      onSelect();
      event.preventDefault();
      break;
    default:
      break;
  }
};
